module.exports = __webpack_public_path__ + "static/media/okta.9fe419ca.svg";